import '@/installCompositionApi'

import { mount } from '@/mounter'

import SanitasMagazineDossierFooter from '../common/DossierFooter'
import SanitasMagazineTeasers from '../common/MagazineTeasers'
import SanitasMagazineFooter from './footer/MagazineFooter'
import PrintCard from './footer/PrintCard'
import SanitasHeaderTeaser from './HeaderTeaser'
import SanitasMagazineOverview from './MagazineOverview'

mount('magazine-overview', {
  SanitasMagazineOverview,
  SanitasMagazineTeasers,
  SanitasMagazineFooter,
  SanitasMagazineDossierFooter,
  PrintCard,
  SanitasHeaderTeaser,
})
